import React, { useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Paper,
  Button,
  CircularProgress,
  IconButton,
  Stack,
  TextField,
  Tooltip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import baseURL from "../../../config";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const FormIModal = ({ open, setOpen, formIData }) => {
  const [activeRowIndex, setActiveRowIndex] = useState(-1);
  const [cocDates, setCocDates] = useState({});
  const [loadingIndex, setLoadingIndex] = useState(-1);
  const [toast, setToast] = useState({ open: false, message: "", severity: "success" });

  const showToast = (message, severity) => {
    setToast({ open: true, message, severity });
    alert(`${severity.toUpperCase()}: ${message}`);
  };

  const userID = localStorage.getItem("user id");
  // console.log("formIData new ", formIData)

  const handleStatusUpdate = async (index) => {
    const cocDate = cocDates[index];
    if (!cocDate) {
      showToast("Please enter a date.", "error");
      return;
    }

    const contract = formIData[index]

    // console.log("contract new", contract)
    if (!contract) {
      showToast("Invalid contract data", "error");
      return;
    }

    setLoadingIndex(index);
    try {
      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${baseURL}/api/statusAfterForm1`,
        {
          contractId: contract?.contractDetails?._id,
          coc: [{ Date: cocDate }],
          creatorId: userID,
          crewId: contract?.contractDetails?.crewdetails?.crewId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      toast.success(response.data.message || "Status updated successfully.");
      setActiveRowIndex(-1);
      setCocDates({});
      setTimeout(() => window.location.reload(), 1000);
    } catch (error) {
      console.error("Error updating status:", error);
      showToast(
        error.response?.data?.message || "Failed to update status",
        "error"
      );
    } finally {
      setLoadingIndex(-1);
    }
  };

  if (!open || !formIData?.length) return null;

  return (
    <Box p={3}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h6">Form I Summary</Typography>
        <Button onClick={() => setOpen(null)} variant="outlined" size="small">
          Close
        </Button>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Sr. No.</TableCell>
              <TableCell>Vessel Name</TableCell>
              <TableCell>Crew Info</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {formIData.map((item, index) => {
              const contract = item.contractDetails;
              const vesselName = contract?.ShipDetails?.vesselname || "N/A";
              const crewName = contract?.crewdetails?.name || "N/A";
              const indosNo = contract?.crewdetails?.indosno || "N/A";
              const rankName = contract?.crewdetails?.rankname || "N/A";

              // console.log("item", item)

              return (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{vesselName}</TableCell>
                  <TableCell>
                    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                      <Chip label={`Crew: ${crewName}`} size="small" />
                      <Chip label={`Indos: ${indosNo}`} size="small" />
                      <Chip label={`Rank: ${rankName}`} size="small" />
                    </Box>
                  </TableCell>
                  <TableCell>
                    {activeRowIndex === index ? (
                      <Stack direction="row" spacing={1} alignItems="center">
                        <TextField
                          type="date"
                          label="COC Date"
                          InputLabelProps={{ shrink: true }}
                          value={cocDates[index] || ""}
                          onChange={(e) =>
                            setCocDates({ ...cocDates, [index]: e.target.value })
                          }
                          size="small"
                          sx={{ width: "160px" }}
                          inputProps={{
                            max: new Date().toISOString().split("T")[0],
                          }}
                        />
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          onClick={() => handleStatusUpdate(index)}
                          disabled={loadingIndex === index}
                        >
                          {loadingIndex === index ? (
                            <CircularProgress size={20} color="inherit" />
                          ) : (
                            "Submit"
                          )}
                        </Button>
                        <IconButton
                          size="small"
                          color="default"
                          onClick={() => setActiveRowIndex(-1)}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </Stack>
                    ) : (
                      <Tooltip title="Add COC Date">
                        <IconButton
                          color="primary"
                          onClick={() => setActiveRowIndex(index)}
                          size="small"
                        >
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <ToastContainer position="top-right" autoClose={3000} />
    </Box>
  );
};

export default FormIModal;
